export const EVENT_POINT = `
	query eventPoint($event_id: Uint) {
		eventPoint(event_id: $event_id) {
			id
			name
			active
			image_url
		}
	}
`;

export const ATTENDEE_POINTS = `
	query attendeePoints($attendee_id: Uint, $event_id: Uint) {
		attendeePoints(attendee_id: $attendee_id, event_id: $event_id) {
			id
			value
			type
			type_id
			reason
			created_at
			updated_at
		}
	}
`;

export const ATTENDEES_POINTS = `
	query attendeesPoints($event_id: Uint) {
		attendeesPoints(event_id: $event_id) {
			id
			value
			type
			reason
			created_at
			attendee {
				first_name
				last_name
				email
			}
		}
	}
`;
